@if (props.class) {
  <div [ngClass]="'alert ' + props.class">
    {{ props.label }}
  </div>
}

@if (!props.class) {
  <h4>{{ props.label }}</h4>
}
